export const ratings = [
    {
        image: require('../../assets/images/TestimonialImages/AdityaGoyal.png'),
       content: `Yogita Ma’am is a gem of a teacher. I was her student in high school,
       and her teaching style of Computer Science was truly transformative.
       She broke down complex concepts into bite-sized pieces, which made
       learning easy and fun. Her wealth of knowledge in the field was evident
       from the way she answered all complex questions. She was a firm
       believer that there are no bad questions. We had the comfort of
       clarifying all our doubts, which helped us during exams. I give her huge
       credit for helping me get a 100% in both 10th and 12th grades. Along
       with high school Computer Science, I took the Advanced Placement
       (AP) CS A exam to strengthen my college application, and she was the
       one I could count on; she is the reason why I achieved a perfect score
       on the test. Looking back, she had a profound impact on my journey to
       become a professional Computer Scientist and secure offers from IBM
       and Nvidia. I highly recommend her.`,
       name: `Aditya Goyal `,
       designation: ``,
       ratings: 3.5,
   },
    {
        image: require('../../assets/images/TestimonialImages/Riddhi.png'),
        content: `Yogita ma’am, I want to let you know how grateful I am for all that you have
        taught me. Till this day, I am so clear on all my concepts. I cannot stress this
        enough ma’am, but all the knowledge that you have imparted still helps me in
        the present. When I see students today struggling with coding in college, I
        always think of you and cannot help but feel grateful that I got to study under
        your guidance. I hope I get to be your student again once.`,
        name: `Riddhi`,
        designation: "",
        ratings: 4,
    },
   
    {
        image: require('../../assets/images/TestimonialImages/Shanvi.png'),
        content: `Yogita ma’am has a unique style of teaching computers to students. She is focused, friendly, understanding and takes responsibility of each student
        associated with her. I remember her giving me a chocolate before my computer exam. It mattered to me. Sometimes, motivation and trust is all we
        students need from a teacher.`,
        name: `Shaanvi`,
        designation: ``,
        ratings: 3.2,
    },
    {
        image: require('../../assets/images/TestimonialImages/Keya.png'),
        content: `Yogita ma’am, is by far the best computer science teacher you can find in the whole of Dehradun. It is because of her efforts, the way she converts complicated questions into easy to understand concepts, that I was able to score a 100 on my class 10 ICSE Board Examinations. Yogita ma’am is known for her mnemonics, memorisation techniques, systematic notes, and her easy-going nature. She is able to engage every student in the class while also maintaining discipline. 
        Thank you so much ma’am.`,
        name: `Keya`,
        designation: ``,
        ratings: 4,
    },
    {
        // image: require('../../assets/images/TestimonialImages/Riddhi.png'),
       content: `Yogita  ma’am's computer teaching skills are outstanding! Her ability to
       explain complex concepts in a clear and engaging manner makes
       learning enjoyable and easy. Her patience and willingness to answer
       questions creates a positive and supportive learning environment.
        ma’am has a natural talent for understanding her students&#39; needs and
       adjusting her teaching approach accordingly.`,
       name: `Tamanna Khurana  `,
       designation: ``,
       ratings: 2.8,
   },
    {
        
        content: `I want to express my gratitude to you, Yogita ma’am for your unwavering support and encouragement during my journey as a student. Your belief in
        me and my potential, your guidance, and your kindness and dedication have made a significant impact on my life. I am thankful to have had you as my
        teacher. With sincere appreciation…`,
        name: `Kinshuk Kathuria`,
        designation: ``,
        ratings: 2.5,
    },
    {
        // image: require('../../assets/images/others/testimonial01.jpg'),
        content: `I came to Yogita Ma’am when I wasn’t performing well in computers.
        Despite being academically strong, I was just not able to perform well in
        the preliminary exams due to lack of right guidance. I attended her
        classes for 2-3 months until the board exams and ended up scoring a
        99. I remember realising I have made a mistake after giving the exam
        and crying frantically. I wanted to score a 100 for her because it was all
        her hard work and I wanted to give something back. There are some
        teachers who leave an impression on you and she is surely one of
        them. Her dedication, knowledge, commitment and zeal to put in that
        additional effort and support in achieving the desired result is truly
        commendable and admirable. I would have never been able to score
        well had it not been for her. All the very best for the journey Ma’am. It
        has been my privilege to be your student.`,
        name: `Parth`,
        designation: ``,
        ratings: 4.9,
    },
    {
       // image: require('../../assets/images/TestimonialImages/AdityaGoyal.png'),
        content: `Words cannot express my gratitude as a parent for having such an
        exceptional computer tuition teacher like Yogita  ma’am for my son. She
        has a remarkable ability to explain complex concepts in a clear and
        easily understandable manner. She also creates a positive and
        engaging learning environment, making every session enjoyable and
        productive. Not only is Yogita  ma’am highly knowledgeable, she also
        cares genuinely about her students&#39; progress and well-being, offering
        them individual attention and support. Her enthusiasm for the subject is
        infectious, and it has inspired my son to delve deeper into the world of
        computers and technology.`,
        name: `Aditya Naik`,
        designation: ``,
        ratings: 4.3,
    },
    {
        // image: require('../../assets/images/others/testimonial01.jpg'),
        content: `I had the most incredible computer teacher during school (Class 9-12),
        who taught me Java for four years and Python for CUET. From the
        beginning, it was evident that this teacher was no ordinary instructor.
        Her passion for coding and teaching was infectious, and she had a
        unique way of making the subject not just understandable but genuinely
        enjoyable. A genuine effort was made to get to know each one of us
        individually, tailoring her approach to suit our learning styles. This
        personal touch not only made us feel valued as students but also
        created a comfortable and supportive learning environment. She has
        made coding so much easier for us that now when I am in college
        where my peers have a difficult time understanding everything, I
        possess clarity of concepts from the beginning. Yogita ma’am is the
        best teacher you can find for computers; she has made my college life
        so much easier!`,
        name: `Anonymous `,
        designation: ``,
        ratings: 4.7,
    },
    
    {
        // image: require('../../assets/images/others/testimonial01.jpg'),
        content: `I first got the opportunity to get tutored by Yogita  ma’am when I was in
        10th grade. I was really bad at computer science and used to barely
        pass my exams. Yogita  ma’am taught me right from scratch, helped me
        build my basics and made sure that not only did I ace my exams but
        also understood every concept in depth. It is all because of her
        constant efforts that I was able to secure 99/100 in computer science in
        both grade 10 ICSE and 12 ISC board exams. She was always there
        when we needed her, even on the nights before the board
        examinations, giving each student personal attention. If you wish to
        grasp the nuances of computer science and ace your exams, she is the
        one who can make it happen!`,
        name: `Udayveer Mittal (Batch: 2017)`,
        designation: ``,
        ratings: 4.1,
    },
   
    {
        // image: require('../../assets/images/others/testimonial01.jpg'),
        content: `When Yogita ma’am started teaching me computers, I absolutely fell in
        love with the subject. She made progamming so interesting and easy!
        Computers is a subject where we need guidance, intellect and interest
        and ma’am helped every student develop these skills. Aside from the
        academics, she is warm and friendly, and creates a positive
        environment for us to learn in. In all, if you want to become skilled and
        a pro at solving every kind of programme, then Yogita ma’am is the go-
        to person for that! Always thankful and grateful to her.`,
        name: `Kavya  `,
        designation: ``,
        ratings: 4,
    },
    {
        // image: require('../../assets/images/others/testimonial01.jpg'),
        content: `Yogita Madam taught me from (2018-2020 )
        I got the privilege that madam taught me computers and I absolutely fell in love with subject. Madam made progamming so interesting and easy !!! 
        Computers is a subject where we need guidance , intellect and interest and madam made every student develop these skills. Aside academics madam has a very friendly nature with her students which is a very positive thing and it maintains a very good atmosphere of the class as well . 
        In all if you want to be skilled and become a pro to solve every kind of program then definitely Yogita madam is the go to person. 
        Always thankful and grateful to her , for all my future endeavors. Thank you ma’am
        `,
        name: `Kavya  `,
        designation: ``,
        ratings: 4,
    },
    {
        // image: require('../../assets/images/others/testimonial01.jpg'),
        content: `I first got the opportunity to learn and get tutored from Yogita ma'am when I was in 10th grade. I was really bad at computer science and used to barely pass my exams. Yogita ma'am taught me right from scratch, helped me build my basics and made sure that not only do I ace my examinations but also understand each and every concept in depth.  It is all because of her constant efforts that I was able to secure 99/100 in computer science in both grade 10 ICSE and 12 ISC board exams. She was always there in time of need even on the nights before the board examinations and always gave personal attention to each and every student in the batch. I highly recommend getting tutored by her if you wish to grasp the nuances of computer science and ace in your examinations.`,
        name: `Udayveer`,
        designation: ``,
        ratings: 4,
    },
    {
        image: require('../../assets/images/TestimonialImages/Riddhi.png'),
        content: `I wanted to drop in and let you know how grateful I am for all that you have taught me. Till this day I am so clear on all my concepts. I cannot stress this enough maam, but all the knowledge that you have imparted is really helping me till the present day, especially when I see other students struggling with coding in college, I always think of you and cannot help but be so grateful that I got to study under your guidance. I hope I get to be your student again once ❤️🙏🏻`,
        name: `Riddhi`,
        designation: ``,
        ratings: 4,
    },
    {
        // image: require('../../assets/images/others/testimonial01.jpg'),
        content: `As I reflect on the past five years of my journey in computer science, I find myself overwhelmed with gratitude for Yogita ma'am's  unwavering dedication and exceptional teaching prowess. Her passion for the subject is infectious, and her commitment to nurturing each student's potential is nothing short of inspiring. I truly admire her dedication and availability as she was always available to address my concerns and answer my questions. Yogita ma'am' s  impact extends far beyond the realm of academia. She is not just a teacher- she is a mentor, a guide, and a role model. Her passion for computer science has ignited a flame within me that will continue to burn brightly for years to come.`,
        name: `Saksham Mittal`,
        designation: ``,
        ratings: 4,
    },
    {
        // image: require('../../assets/images/others/testimonial01.jpg'),
        content: `I'm writing to express my sincere gratitude to Yogita Ma’am who has taught me computers from Class 10th to 12th. Her exceptional teaching style and dedication to her students have had a profound impact on my life.
        Mam's way of explaining the trickiest concepts in a clear and concise way made computer an engaging and enjoyable subject for me.No matter how complex the topic would be,mam would break it down into simpler steps and relatable examples.Ma'am created a comfortable learning environment in her classes.I never felt hesitant to ask questions or clear any doubts.
        I had the privilege of learning from her and undoubtedly computers went from a mysterious subject to one of my favorites.Ma'am made computer learning fun, effective, and long-lasting.
        The skills and knowledge I gained in her classes have given me a significant advantage even when I'm persuing Bachelors of Computer Applications.
        Mam's ability to connect with students is truly commendable and her exceptional teaching methods make her an outstanding educator.
        I cannot thank mam enough for how much she has helped me all through the years as a mentor and the best teacher ever.
        `,
        name: `Vanshika`,
        designation: ``,
        ratings: 4,
    },
    
]